import Transition from '@/utils/Transition'
import { cookies_domain_name } from 'constant/url'
import { setCookies } from 'cookies-next'
import React, { useRef, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

function Sidepan({
  children,
  id,
  sidepanOpen,
  setSidepanOpen,
  justify_align,
  closeByOutsideClick,
  closeByEscClick,
  sidepan_component_styles,
  custom_content_box_styles,
  hide_back_shadow,
  fixed_main_width,
}) {
  const modalContent = useRef(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // close on click outside
  useEffect(() => {
    if (closeByOutsideClick) {
      const clickHandler = ({ target }) => {
        if (
          !sidepanOpen ||
          modalContent.current.contains(target) ||
          target?.id?.includes('react-select')
        )
          return
        setSidepanOpen(false)
      }
      document.addEventListener('click', clickHandler)
      return () => document.removeEventListener('click', clickHandler)
    }
  })

  // close if the esc key is pressed
  useEffect(() => {
    if (closeByOutsideClick || closeByEscClick) {
      const keyHandler = ({ keyCode }) => {
        if (!sidepanOpen || keyCode !== 27) return
        setSidepanOpen(false)
      }
      document.addEventListener('keydown', keyHandler)
      return () => document.removeEventListener('keydown', keyHandler)
    }
  })

  // Return null during SSR
  if (!mounted) return null

  // Only create portal on client-side
  const portalElement = typeof window !== 'undefined' ? document.body : null
  if (!portalElement) return null

  return createPortal(
    <>
      {/* Modal backdrop */}
      {hide_back_shadow !== true && (
        <Transition
          className="fixed inset-0 bg-gray-900 bg-opacity-30  z-100 transition-opacity"
          show={sidepanOpen}
          enter="transition ease-out duration-200"
          enterStart="opacity-0"
          enterEnd="opacity-100"
          leave="transition ease-out duration-100"
          leaveStart="opacity-100"
          leaveEnd="opacity-0"
          aria-hidden="true"
        />
      )}
      {/* Modal dialog */}
      <Transition
        id={id}
        className={[
          'fixed inset-0 z-100  overflow-hidden flex items-center    transform ',
          justify_align ? `justify-${justify_align}` : 'justify-end',
          fixed_main_width ? fixed_main_width : 'w-auto',
        ].join(' ')}
        role="dialog"
        aria-modal="true"
        show={sidepanOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className={[
            'bg-white   shadow-lg overflow-auto  rounded-md  max-h-full  ',
            sidepan_component_styles ?? '',
            custom_content_box_styles,
          ].join(' ')}
        >
          {children}
        </div>
      </Transition>
    </>,
    portalElement
  )
}

export default Sidepan
